import { useState, useEffect, useRef } from "react";
import api from "../api";

const API = process.env.REACT_APP_API_URL;


function Fees() {

  const [search, setSearch] = useState("");
  const [student, setStudent] = useState(null);
  const [routes, setRoutes] = useState([]);
  const [feetype, setfeetype] = useState("");
  const [months, setMonths] = useState([]);
  const [amount, setAmount] = useState(0);
  const [concession, setConcession] = useState(0);
  const [payable, setPayable] = useState(0);
  const [amountPaid, setAmountPaid] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [paidMonths, setPaidMonths] = useState([]);
  const [results, setResults] = useState([]);
  const [feeData, setFeeData] = useState([]);
  const [history, setHistory] = useState([]);
  const [totalDue, setTotalDue] = useState(0);
  const [loadingDue, setLoadingDue] = useState(false);
  const [summary, setSummary] = useState(null);
  const [payments, setPayments] = useState([]);
  //const [admissionType, setAdmissionType] = useState("");


  const searchRef = useRef(null);

  const getCurrentMonth = () => {
    return new Date().toLocaleString("en-IN", { month: "long" });
  };

  const paymentMap = {};

  payments.forEach(p => {
    if (!paymentMap[p.feetype]) {
      paymentMap[p.feetype] = {};
    }

    paymentMap[p.feetype][p.month] = {
      paid: Number(p.paid || 0),
      conc: Number(p.concession || 0)
    };
  });



  useEffect(() => {

    if (!feetype || !summary) return;

    let total = 0;

    // ✅ Admission & Exam → ONE TIME (no months)
    if (feetype === "Admission") {
      const expected = Number(summary.admissionExpected || 0);
      const paid = Number(summary.paidadmission || 0);
      const conc = Number(summary.concessionadmission || 0);

      const due = expected - paid - conc;

      total = due > 0 ? due : 0;
    }

    else if (feetype === "Exam") {
      const expected = Number(summary.examfee || 0);
      const paid = Number(summary.paidexam || 0);
      const conc = Number(summary.concessionexam || 0);

      const due = expected - paid - conc;

      total = due > 0 ? due : 0;
    }

    // ✅ Monthly types
    else {
      months.forEach(m => {
        const existing = paymentMap[feetype]?.[m] || {};
        const paid = existing.paid || 0;
        const conc = existing.conc || 0;

        const expected =
          feetype === "Tuition"
            ? Number(summary.tuitionfee || 0)
            : Number(summary.routefare || 0);

        const due = expected - paid - conc;

        if (due > 0) total += due;
      });
    }

    setAmount(total);
    setPayable(total - concession);

  }, [months, feetype, concession, summary, paymentMap]);


  const monthMap = {
    April: 1, May: 2, June: 3, July: 4,
    August: 5, September: 6, October: 7,
    November: 8, December: 9, January: 10,
    February: 11, March: 12
  };

  const currentMonth = new Date().toLocaleString("en-IN", { month: "long" });
  const monthsCount = monthMap[currentMonth] || 1;



  const allMonths = [
    "April", "May", "June", "July", "August",
    "September", "October", "November", "December",
    "January", "February", "March"
  ];

  const currentIndex = allMonths.indexOf(currentMonth);
  const startMonth = allMonths[0];
  const endMonth = allMonths[currentIndex] || "April";

  useEffect(() => {

    api.get(`${API}/conveyance`)

      .then(res => setRoutes(res.data))
      .catch(err => console.log(err));
  }, []);

  // 🔹 Fetch Fee Structure
  useEffect(() => {

    api.get(`${API}/fee-structure`)

      .then(res => setFeeData(res.data))
      .catch(err => console.log(err));
  }, []);

  // 🔹 Auto focus search
  useEffect(() => {
    searchRef.current?.focus();
  }, []);

  // 🔹 Fetch History when student changes (FIXED)
  useEffect(() => {
    if (student?.admno) {

      api.get(`${API}/payments/${student.admno}`)

        .then(res => setHistory(res.data))
        .catch(err => console.log(err));
    } else {
      setHistory([]);
    }
  }, [student]);

  // 🔹 Fetch Paid Months
  const fetchPaidMonths = (admNo, type) => {
    if (!admNo || !type) return;


    api.get(`${API}/payments/${admNo}/${type}`)

      .then(res => {
        const months = res.data.map(r => r.month);
        setPaidMonths(months);
      })
      .catch(err => console.log(err));
  };

  const fetchSummary = (admNo) => {
    setLoadingDue(true);

    api.get(`${API}/student-fee-summary/${admNo}`)
      .then(res => {
        if (!res.data) {
          setTotalDue(0);
        } else {
          setSummary(res.data);
          setTotalDue(res.data.totalDue);
          setPayments(res.data.payments || []);
        }
        setLoadingDue(false);
      })
      .catch(() => setLoadingDue(false));
  };

  // 🔹 Search Student
  const handleSearch = () => {



    if (!search.trim()) {
      alert("Enter name or admission number");
      return;
    }

    // 🔥 Reset form on new search
    setfeetype("");
    setMonths([]);
    setAmount(0);
    setConcession(0);
    setPayable(0);
    setAmountPaid(0);


    api.get(`${API}/search-student/${search}`)

      .then(res => {

        const keyword = search.trim().toLowerCase();

        const matches = res.data;

        if (matches.length === 0) {
          alert("Student not found");

        } else if (matches.length === 1) {

          const s = matches[0];
          setStudent(s);

          fetchSummary(s.admno);


          setResults([]);
          setPaidMonths([]);
          setfeetype("");
          //setMonth("");

        } else {
          setResults(matches);
        }

      })
      .catch(err => console.log(err));
  };

  // 🔹 Calculate Amount
  const calculateAmount = (type, cons = concession) => {

    if (!student || !type) return;

    const classData = feeData.find(f => f.class_name === student.class_name);
    if (!classData) return;

    let base = 0;

    if (type === "Tuition") base = classData.tuitionfee;
    else if (type === "Exam") base = classData.examfee;
    else if (type === "Admission") {
      base =
        (student.admissiontype || "New") === "Old"
          ? Number(classData.oldadmissionfee || 0)
          : Number(classData.newadmissionfee || 0);
    }
    else if (type === "Conveyance") {
      const route = routes.find(r => r.routeno === student.routeno);
      base = route ? route.routefare : 0;
    }

    const totalMonths = months.length || 1;
    setAmount(base * totalMonths);
    setPayable((base * totalMonths) - cons);
  };

  const distributePayment = (monthsList, feetype, totalPaid, totalConcession) => {
    const result = [];

    let remainingPaid = Number(totalPaid);
    let remainingConcession = Number(totalConcession);

    const expectedPerMonth =
      feetype === "Tuition"
        ? Number(summary.tuitionfee || 0)
        : feetype === "Conveyance"
          ? Number(summary.routefare || 0)
          : 0;

    monthsList.forEach((m) => {
      const existing = paymentMap[feetype]?.[m] || {};
      const alreadyPaid = existing.paid || 0;
      const alreadyConc = existing.conc || 0;

      const remainingExpected = expectedPerMonth - alreadyPaid - alreadyConc;

      if (remainingExpected <= 0) return;

      // Apply concession first
      const conc = Math.min(remainingConcession, remainingExpected);
      remainingConcession -= conc;

      const afterConc = remainingExpected - conc;

      // Apply payment
      const pay = Math.min(remainingPaid, afterConc);
      remainingPaid -= pay;

      result.push({
        month: m,
        amount: expectedPerMonth,
        concession: conc,
        payable: afterConc,
        paid: pay
      });
    });

    return result;
  };

  // 🔹 Save Payment
  const handleSave = () => {

    if (!receiptNo || receiptNo.trim() === "") {
      alert("Receipt No is required");
      return;
    }

    const totalDue = Number(summary.totalDue || 0);

    if (totalDue <= 0) {
      alert("No due remaining. Payment not allowed.");
      return;
    }

    // ✅ Validation
    if (!student || !amountPaid || !feetype ||
      ((feetype !== "Admission" && feetype !== "Exam") && months.length === 0)) {
      alert("Fill all required fields");
      return;
    }

    // 🚫 Prevent zero or negative payment
    if (Number(amountPaid) <= 0) {
      alert("Amount Paid must be greater than 0");
      return;
    }

    // ✅ Overpayment check
    if (Number(amountPaid) > payable) {
      alert("Amount exceeds payable");
      return;
    }

    // ✅ Handle single vs multi month
    const selectedMonths =
      (feetype === "Admission" || feetype === "Exam")
        ? ["One-Time"]
        : months;

    // 🚫 Prevent gaps (e.g. May + July)
    const selectedIndexes = selectedMonths
      .map(m => allMonths.indexOf(m))
      .sort((a, b) => a - b);

    // ✅ NEW CHECK (no gaps)
    for (let i = 1; i < selectedIndexes.length; i++) {
      if (selectedIndexes[i] !== selectedIndexes[i - 1] + 1) {
        alert("⚠️ Please select continuous months (no skipping)");
        return;
      }
    }

    // 🚫 Prevent skipping previous unpaid months
    if (feetype === "Tuition" || feetype === "Conveyance") {

      const selectedIndexes = selectedMonths
        .map(m => allMonths.indexOf(m))
        .sort((a, b) => a - b);

      const firstSelectedIndex = selectedIndexes[0];

      for (let i = 0; i < firstSelectedIndex; i++) {
        const m = allMonths[i];

        const existing = paymentMap[feetype]?.[m] || {};
        const paid = existing.paid || 0;
        const conc = existing.conc || 0;

        const expected =
          feetype === "Tuition"
            ? Number(summary.tuitionfee || 0)
            : Number(summary.routefare || 0);

        const due = expected - paid - conc;

        if (due > 0) {
          alert(`⚠️ ${m} is still due. Please pay in order.`);
          return;
        }
      }
    }

    const count = selectedMonths.length;



    let distribution = [];

    if (feetype === "Tuition" || feetype === "Conveyance") {
      distribution = distributePayment(
        selectedMonths,
        feetype,
        amountPaid,
        concession
      );
    } else {
      distribution = selectedMonths.map(m => ({
        month: m,
        amount: amount,
        concession: concession,
        payable: payable,
        paid: Number(amountPaid)
      }));
    }

    if (distribution.length === 0) {
      alert("No valid dues to pay");
      return;
    }

    const requests = distribution.map(d => {
      return api.post(`${API}/add-payment`, {
        ReceiptNo: receiptNo || "R" + Date.now(),
        AdmNo: student.admno,
        FeeType: feetype,
        Month:
          feetype === "Admission"
            ? "ADM-" + Date.now().toString().slice(-4)
            : d.month,
        Amount: d.amount,
        Concession: d.concession,
        Payable: d.payable,
        AmountPaid: d.paid,
        Mode: paymentMode,
        Date: new Date().toISOString().split("T")[0]
      });
    });



    // ✅ Execute all
    Promise.all(requests)
      .then(() => {

        alert("Payment Saved");

        // 🔥 Refresh total due
        fetchSummary(student.admno);

        // 🔥 Refresh history
        api.get(`${API}/payments/${student.admno}`)
          .then(res => setHistory(res.data));

        // 🔄 Reset form
        setMonths([]);
        setAmountPaid("");
        setReceiptNo("");
        setPaymentMode("");
        setConcession(0);
        setAmount(0);
        setPayable(0);
        setfeetype("");


      })
      .catch(err => {
        console.log(err);

        alert("Error saving payment");

      });
  };

  //press enter key to save payment
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {

        // ❌ Ignore if typing in search box
        if (document.activeElement === searchRef.current) return;

        // ✅ Call save
        handleSave();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleSave]);

  const availableMonths = allMonths.filter(m => !paidMonths.includes(m));

  // 🔹 Styles
  const labelStyle = { fontSize: "13px", color: "#555", marginBottom: "4px" };

  const inputStyle = {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    width: "100%"
  };

  const readOnlyStyle = {
    ...inputStyle,
    background: "#f9fafb"
  };

  const handlePrint = (data) => {

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
    <html>
      <head>
        <title>Receipt</title>
        <style>
          body { font-family: Arial; padding: 20px; }
          h2 { text-align: center; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          td { padding: 8px; border: 1px solid #ccc; }
        </style>
      </head>
      <body>

        <h2>School Fee Receipt</h2>

        <table>
          <tr><td><b>Receipt No</b></td><td>${data.ReceiptNo}</td></tr>
          <tr><td><b>Student Name</b></td><td>${student.name}</td></tr>
          <tr><td><b>Admission No</b></td><td>${student.admno}</td></tr>
          <tr><td><b>Class</b></td><td>${student.class_name}-${student.section}</td></tr>
          <tr><td><b>Fee Type</b></td><td>${data.feetype}</td></tr>
          <tr><td><b>Month</b></td><td>${data.month}</td></tr>
          <tr><td><b>Amount</b></td><td>${data.Amount}</td></tr>
          <tr><td><b>Paid</b></td><td>${data.AmountPaid}</td></tr>
          <tr><td><b>Date</b></td><td>${new Date(data.date).toLocaleDateString("en-IN")}</td></tr>
        </table>

      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.print();
  };


  const handleCellClick = (type, month, due) => {
    if (due <= 0) {
      alert("Already fully paid");
      return;
    }

    // prevent mixing types
    if (feetype && feetype !== type) {
      setfeetype(type);
      setMonths([month]);
    } else {
      setfeetype(type);

      setMonths(prev => {
        if (prev.includes(month)) {
          return prev.filter(m => m !== month);
        } else {
          return [...prev, month];
        }
      });
    }

    // reset manual fields only
    setConcession(0);
    setAmountPaid("");
  };


  return (
    <div style={{
      padding: "30px",
      maxWidth: "1000px",
      margin: "30px auto",
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
    }}>

      <h2 style={{ marginBottom: "25px", borderBottom: "2px solid #eee" }}>
        Fee Payment
      </h2>

      {/* SEARCH */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "25px" }}>
        <input
          ref={searchRef}
          style={inputStyle}
          placeholder="Search by Name / Admission No"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch();
          }}
        />
        <button onClick={handleSearch} style={{
          padding: "10px 20px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer"
        }}>
          Search
        </button>
      </div>

      {/* MULTIPLE RESULTS */}
      {results.length > 0 && (
        <div style={{ border: "1px solid #ddd", borderRadius: "6px" }}>
          {results.map(s => (
            <div key={s.admno}
              style={{ padding: "10px", cursor: "pointer", borderBottom: "1px solid #eee" }}

              onClick={() => {
                setStudent(s);
                fetchSummary(s.admno);   // ✅ THIS IS THE FIX

                setResults([]);
                setPaidMonths([]);
                setfeetype("");

              }}>




              <b>{s.admno} - {s.name}</b><br />
              Father: {s.fathername} | {s.class_name}-{s.section}
            </div>
          ))}
        </div>
      )}

      {student && summary && (
        <div style={{
          background: "#f8fafc",
          padding: "15px",
          borderRadius: "10px",
          marginTop: "20px",
          marginBottom: "10px",
          border: "1px solid #e5e7eb"
        }}>


          <h3>
            Payment Breakdown
            <span>
              ({monthsCount} Months: {startMonth} → {endMonth})
            </span>
          </h3>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Tuition<br /></th>
                <th style={thStyle}>Conveyance<br /></th>
                <th style={thStyle}>Exam<br /></th>
                <th style={thStyle}>Admission<br /></th>
                <th style={thStyle}>Total Due</th>
              </tr>
            </thead>

            <tbody>
              <tr>

                {/* Tuition */}
                <td style={{ ...tdStyle, lineHeight: "1.6" }}>
                  {(() => {
                    const expected = summary.tuitionfee * monthsCount;
                    const due = expected - summary.paidtuition - summary.concessiontuition;

                    return (
                      <>
                        <div>Exp: ₹{expected}</div>
                        <div style={{ color: "#2563eb" }}>Conc: ₹{summary.concessiontuition}</div>
                        <div style={{ color: "green" }}>Paid: ₹{summary.paidtuition}</div>
                        <div style={{
                          color: due > 0 ? "red" : "#059669",
                          fontWeight: "bold"
                        }}>
                          {due >= 0
                            ? `Due: ₹${due}`
                            : `Adv: ₹${Math.abs(due)} `
                          }
                        </div>
                      </>
                    );
                  })()}
                </td>

                {/* Conveyance */}
                <td style={{ ...tdStyle, lineHeight: "1.6" }}>
                  {(() => {
                    const expected = summary.routefare * monthsCount;
                    const due = expected - summary.paidtransport - summary.concessiontransport;

                    return (
                      <>
                        <div>Exp: ₹{expected}</div>
                        <div style={{ color: "#2563eb" }}>Conc: ₹{summary.concessiontransport}</div>
                        <div style={{ color: "green" }}>Paid: ₹{summary.paidtransport}</div>
                        <div style={{
                          color: due > 0 ? "red" : "#059669",
                          fontWeight: "bold"
                        }}>
                          {due >= 0
                            ? `Due: ₹${due}`
                            : `Adv: ₹${Math.abs(due)}`
                          }
                        </div>
                      </>
                    );
                  })()}
                </td>

                {/* Exam */}
                <td style={{ ...tdStyle, lineHeight: "1.6" }}>
                  {(() => {
                    const expected = summary.examfee;
                    const due = expected - summary.paidexam - summary.concessionexam;

                    return (
                      <>
                        <div>Exp: ₹{expected}</div>
                        <div style={{ color: "#2563eb" }}>Conc: ₹{summary.concessionexam}</div>
                        <div style={{ color: "green" }}>Paid: ₹{summary.paidexam}</div>
                        <div style={{
                          color: due > 0 ? "red" : "#059669",
                          fontWeight: "bold"
                        }}>
                          {due >= 0
                            ? `Due: ₹${due}`
                            : `Adv: ₹${Math.abs(due)}`
                          }
                        </div>
                      </>
                    );
                  })()}
                </td>

                {/* Admission */}
                <td style={{ ...tdStyle, lineHeight: "1.6" }}>
                  {(() => {
                    const expected = Number(summary.admissionExpected || 0);
                    const paid = Number(summary.paidadmission || 0);
                    const conc = Number(summary.concessionadmission || 0);

                    const due = expected - paid - conc;

                    return (
                      <>
                        <div>Exp: ₹{expected}</div>
                        <div style={{ color: "#2563eb" }}>Conc: ₹{summary.concessionadmission}</div>
                        <div style={{ color: "green" }}>Paid: ₹{summary.paidadmission}</div>
                        <div style={{
                          color: due > 0 ? "red" : "#059669",
                          fontWeight: "bold"
                        }}>
                          {due >= 0
                            ? `Due: ₹${due}`
                            : `Adv: ₹${Math.abs(due)}`
                          }
                        </div>
                      </>
                    );
                  })()}
                </td>

                {/* Total Due */}
                <td style={{
                  ...tdStyle,
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: summary.totalDue > 0 ? "red" : "#059669",
                  textAlign: "center",        // ✅ horizontal
                  verticalAlign: "middle",    // ✅ vertical
                  height: "100%"              // optional
                }}>
                  ₹{summary.totalDue}
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      )}
      {summary && (
        <div style={{ marginTop: "20px", overflowX: "auto" }}>
          <table style={{
            borderCollapse: "collapse",
            width: "100%",
            minWidth: "900px",
            fontSize: "14px"
          }}>

            {/* HEADER */}
            <thead>
              <tr>
                <th rowSpan="2" style={thStyle2}>Month</th>

                <th colSpan="4" style={{ ...thStyle2, background: "#facc15" }}>
                  Tuition
                </th>

                {student?.routeno > 0 && (
                  <th colSpan="4" style={{ ...thStyle2, background: "#86efac" }}>
                    Conveyance
                  </th>
                )}
              </tr>

              <tr>
                {["E", "C", "P", "D"].map((h, i) => (
                  <th key={i} style={thStyle}>{h}</th>
                ))}

                {student?.routeno > 0 &&
                  ["E", "C", "P", "D"].map((h, i) => (
                    <th key={"c" + i} style={thStyle}>{h}</th>
                  ))}
              </tr>
            </thead>

            {/* BODY */}
            <tbody>
              {allMonths.map((m) => {
                const tuitionExpected = Number(summary?.tuitionfee || 0);
                const transportExpected = Number(summary?.routefare || 0);

                const t = paymentMap["Tuition"]?.[m] || {};
                const c = paymentMap["Conveyance"]?.[m] || {};

                const paidT = t.paid || 0;
                const concT = t.conc || 0;

                const paidC = c.paid || 0;
                const concC = c.conc || 0;

                // simple distribution (you can improve later)
                const dueT = tuitionExpected - concT - paidT;
                const dueC = transportExpected - concC - paidC;

                return (
                  <tr key={m}>
                    <td style={tdStyle}>{m}</td>

                    {/* TUITION */}
                    <td style={tdStyle2}>₹{tuitionExpected}</td>
                    <td style={{ ...tdStyle2, color: "#2563eb" }}>₹{concT}</td>
                    <td style={{ ...tdStyle2, color: "green" }}>₹{paidT}</td>
                    <td
                      onClick={() => handleCellClick("Tuition", m, dueT)}
                      style={{
                        ...tdStyle2,
                        background: (feetype === "Tuition" && months.includes(m))
                          ? "#dbeafe"
                          : (dueT > 0 ? "#fef2f2" : "#f0fdf4"),
                        color: dueT > 0 ? "red" : "#059669",
                        fontWeight: "bold",
                        cursor: dueT > 0 ? "pointer" : "default",

                      }}
                    >
                      ₹{dueT}
                    </td>
                    {student?.routeno > 0 && (
                      <>
                        <td style={tdStyle2}>₹{transportExpected}</td>
                        <td style={{ ...tdStyle2, color: "#2563eb" }}>₹{concC}</td>
                        <td style={{ ...tdStyle2, color: "green" }}>₹{paidC}</td>
                        <td
                          onClick={() => handleCellClick("Conveyance", m, dueC)}
                          style={{
                            ...tdStyle2,
                            background: (feetype === "Conveyance" && months.includes(m))
                              ? "#dbeafe"
                              : (dueC > 0 ? "#fef2f2" : "#f0fdf4"),
                            color: dueC > 0 ? "red" : "#059669",
                            fontWeight: "bold",
                            cursor: dueC > 0 ? "pointer" : "default"
                          }}
                        >
                          ₹{dueC}
                        </td>
                      </>
                    )}

                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}




      {/* FORM */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "60px",
        rowGap: "15px",
        marginTop: "20px"
      }}>

        <div>
          <div style={labelStyle}>Admission No</div>
          <input style={readOnlyStyle} value={student?.admno || ""} readOnly />

          <div style={labelStyle}>Student Name</div>
          <input style={readOnlyStyle} value={student?.name || ""} readOnly />

          <div style={labelStyle}>Father Name</div>
          <input style={readOnlyStyle} value={student?.fathername || ""} readOnly />

          <div style={labelStyle}>Class</div>
          <input style={readOnlyStyle} value={student?.class_name || ""} readOnly />

          <div style={labelStyle}>Section</div>
          <input style={readOnlyStyle} value={student?.section || ""} readOnly />

          <div style={labelStyle}>Route No</div>
          <input style={readOnlyStyle} value={student?.routeno || ""} readOnly />

          <div style={labelStyle}>Total Dues</div>
          <input
            style={{
              ...readOnlyStyle,
              background: "#fee2e2",
              color: "red",
              fontWeight: "bold"
            }}
            value={loadingDue ? "Calculating..." : `₹${totalDue}`}
            readOnly
          />

        </div>

        <div>
          <div style={labelStyle}>Fee Type</div>
          <select style={inputStyle} value={feetype}
            onChange={(e) => {
              const type = e.target.value;

              // ❌ Block manual selection of monthly types
              if ((type === "Tuition" || type === "Conveyance") && months.length === 0) {
                alert("Please select months from table");
                return;
              }

              setfeetype(type);
              setMonths([]);
            }}>
            <option value="">Select</option>

            {/* Always available */}
            <option>Exam</option>
            <option>Admission</option>

            {/* Only show if selected from table */}
            {months.length > 0 && feetype === "Tuition" && (
              <option>Tuition</option>
            )}

            {months.length > 0 && feetype === "Conveyance" && (
              <option>Conveyance</option>
            )}
          </select>


          {(feetype === "Tuition" || feetype === "Conveyance") && months.length > 0 && (
            <div style={{ marginTop: "10px", fontSize: "14px" }}>
              <strong>Selected Months:</strong>{" "}
              {months.length > 0 ? months.join(", ") : "None"}
            </div>
          )}

          <div style={labelStyle}>Amount</div>
          <input style={{ ...readOnlyStyle, background: "#eef2ff" }} value={amount} readOnly />

          <div style={labelStyle}>Concession</div>
          <input style={inputStyle} value={concession}
            onChange={(e) => {
              const val = Number(e.target.value);
              setConcession(val);
              calculateAmount(feetype, val);
            }} />

          <div style={labelStyle}>Payable</div>
          <input style={{ ...readOnlyStyle, background: "#dcfce7" }} value={payable} readOnly />

          <div style={labelStyle}>Amount Paid</div>
          <input style={inputStyle} value={amountPaid}
            onChange={(e) => setAmountPaid(e.target.value)} />

          <div style={labelStyle}>Receipt No</div>
          <input style={inputStyle} value={receiptNo}
            onChange={(e) => setReceiptNo(e.target.value)} />

          <div style={labelStyle}>Payment Mode</div>
          <select style={inputStyle} value={paymentMode}
            onChange={(e) => setPaymentMode(e.target.value)}>
            <option value="">Select</option>
            <option>Cash</option>
            <option>UPI</option>
            <option>Online</option>
          </select>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={handleSave}
          disabled={!receiptNo || receiptNo.trim() === ""}
          style={{
            marginTop: "25px",
            padding: "12px 25px",
            background: "#16a34a",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          Save Payment
        </button>
      </div>

      {/* HISTORY */}
      {history.length > 0 && (
        <div style={{ marginTop: "30px" }}>
          <h3>Payment History</h3>
          <table border="1" cellPadding="8" width="100%">
            <thead>
              <tr>
                <th>Receipt</th>
                <th>Type</th>
                <th>Month</th>
                <th>Amount</th>
                <th>Paid</th>
                <th>Date</th>
                <th>Print</th>
              </tr>
            </thead>
            <tbody>
              {history.map(h => (
                <tr key={h.receiptno}>
                  <td>{h.receiptno}</td>
                  <td>{h.feetype}</td>
                  <td>{h.month}</td>
                  <td>{h.amount}</td>
                  <td>{h.amountpaid}</td>
                  <td>{new Date(h.date).toLocaleDateString("en-IN")}</td>
                  <td>
                    <button onClick={() => handlePrint(h)}>
                      Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
}

const thStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  background: "#f1f5f9",
  textAlign: "center"
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "left",   // 🔥 change this
  verticalAlign: "top" // 🔥 important for stacked lines
};

const thStyle2 = {
  border: "1px solid #ccc",
  padding: "6px",
  textAlign: "center",
  fontWeight: "bold"
};

const tdStyle2 = {
  border: "1px solid #ddd",
  padding: "6px",
  textAlign: "center"
};
export default Fees;